import { AlertController } from "ionic-angular";
import { MyApp } from "./../../app/app.component";
import { Component, Input, ModuleWithComponentFactories } from "@angular/core";
import * as cbUtil from "../../providers/util-general/util-general";
import * as _ from "lodash";
import { ActServiceProvider } from "../../providers/act-service/act-service";
import { Output, EventEmitter } from "@angular/core";
import moment from "moment";

/**
 * Generated class for the ActPaymentRequestComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "act-payment-request",
  templateUrl: "act-payment-request.html"
})
export class ActPaymentRequestComponent {
  @Input("data") data: any;
  @Input("status") status: any;
  @Input("bgColor") bgColor: any;
  @Input("type") type: any;
  @Output() updateChanged = new EventEmitter<Object>();
  _origData: any = [];
  constructor(
    private actService: ActServiceProvider,
    private alertCtrl: AlertController
  ) {}

  updateList(obj: any) {
    this.updateChanged.emit({
      key: obj.key,
      item: obj.item
    });
  }

  formatNumber(pData) {
    return cbUtil.formatNumber(pData);
  }

  roundNumber(pItem) {
    return cbUtil.formatNumber(Math.round(pItem));
  }

  calculateSubTotal(a, b) {
    return cbUtil.formatNumber(Math.round(a * b));
  }

  splitStopClearedBy(item) {
    if (!item || item == null )
      return "";
    if (!item.STOP_CLEARED_BY || item.STOP_CLEARED_BY == null )
      return "";
    return item.STOP_CLEARED_BY.split(",");
  }

  showRejectNote(item) {
    let alertData = this.alertCtrl.create({
      title: "Ghi chú",
      inputs: [
        {
          name: "reject_note",
          placeholder: "Nhập ghi chú..."
        }
      ],
      buttons: [
        {
          text: "Hủy",
          role: "Cancel",
          handler: data => {
            console.log("Cancel clicked!");
          }
        },
        {
          text: "Xác nhận",
          handler: data => {
            if (data.reject_note.trim() == "") {
              alert("Vui lòng không bỏ trống lí do!");
            } else {
              item["REJECT_NOTE"] = data.reject_note;
              this.rejectExpense(item);
            }
          }
        }
      ]
    });
    alertData.present();
  }

  async approveExpense(item) {
    if (this.type == "Payment") {
      console.log("Approve Payment");
      var dataPayment = {
        paymentRequestID: item.PAYMENT_REQUEST_ID,
        userID: MyApp.getInstance().userService.getUserId()
      };
      var resPayment = await this.actService.doApprovePaymentRequest(
        dataPayment
      );
      console.log(resPayment);
      item.STATUS = "APPROVED";
      _.remove(this.data, function(o) {
        return o.PAYMENT_REQUEST_ID == item.PAYMENT_REQUEST_ID;
      });
    } else if (this.type == "Purchasing") {
      console.log("Approve Purchasing");
      var dataPurchasing = {
        purchaseRequestID: item.PURCHASING_REQUEST_ID,
        userID: MyApp.getInstance().userService.getUserId()
      };
      var resPurchasing = await this.actService.doApprovePurchasingRequest(
        dataPurchasing
      );
      console.log(resPurchasing);
      item.REQUEST_STATUS = "APPROVED";
      _.remove(this.data, function(o) {
        return o.PURCHASING_REQUEST_ID == item.PURCHASING_REQUEST_ID;
      });
    } else if (this.type == "Acceptance") {
      console.log("Approve Acceptance");
      var dataAcceptance = {
        paymentRequestID: item.payment_request_acceptance_id,
        userID: MyApp.getInstance().userService.getUserId()
      };
      var resAcceptance = await this.actService.doApprovePaymentRequestAcceptance(
        dataAcceptance
      );
      console.log(resAcceptance);
      item.status = "APPROVED";
      _.remove(this.data, function(o) {
        return (
          o.payment_request_acceptance_id == item.payment_request_acceptance_id
        );
      });
    }
    this.updateList({
      key: "approve",
      item: item
    });
  }

  async rejectExpense(item) {
    if (this.type == "Payment") {
      console.log("Reject Payment");
      var dataPayment = {
        paymentRequestID: item.PAYMENT_REQUEST_ID,
        userID: MyApp.getInstance().userService.getUserId(),
        rejectNote: item.REJECT_NOTE,
        description: item.DESCRIPTION
      };
      var resPayment = await this.actService.doRejectPaymentRequest(
        dataPayment
      );
      console.log(resPayment);
      item.STATUS = "REJECT";
      _.remove(this.data, function(o) {
        return o.PAYMENT_REQUEST_ID == item.PAYMENT_REQUEST_ID;
      });
    } else if (this.type == "Purchasing") {
      console.log("Reject Purchasing");
      var dataPurchasing = {
        purchaseRequestID: item.PURCHASING_REQUEST_ID,
        userID: MyApp.getInstance().userService.getUserId(),
        rejectNote: item.REJECT_NOTE,
        description: item.DESCRIPTION
      };
      var resPurchasing = await this.actService.doRejectPurchasingRequest(
        dataPurchasing
      );
      console.log(resPurchasing);
      item.REQUEST_STATUS = "REJECT";
      _.remove(this.data, function(o) {
        return o.PURCHASING_REQUEST_ID == item.PURCHASING_REQUEST_ID;
      });
    } else if (this.type == "Acceptance") {
      console.log("Reject Acceptance");
      var dataAcceptance = {
        paymentRequestID: item.payment_request_acceptance_id,
        userID: MyApp.getInstance().userService.getUserId(),
        rejectNote: item.REJECT_NOTE,
        description: item.description
      };
      var resAcceptance = await this.actService.doRejectPaymentRequestAcceptance(
        dataAcceptance
      );
      console.log(resAcceptance);
      item.status = "REJECT";
      _.remove(this.data, function(o) {
        return o.PURCHASING_REQUEST_ID == item.PURCHASING_REQUEST_ID;
      });
    }
    this.updateList({
      key: "reject",
      item: item
    });
  }

  changeColorByStatus() {
    var statusList = (<HTMLCollection>(
      document.getElementsByClassName("status")
    )) as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < statusList.length; i++) {
      statusList[i].style.backgroundColor = this.bgColor;
    }
  }

  getItems(ev: any) {
    this.data = this._origData;
    const val = ev.target.value;
    console.log(val);
    if (!this.data) {
      alert("data not found");
      return;
    }

    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      this.data = this.data.filter(item => {
        return (
          this.stringToSlug(item.REQUEST_NUMBER)
            .toLowerCase()
            .indexOf(val.toLowerCase()) > -1
        );
      });
    }
  }

  stringToSlug(str) {
    var from =
        "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñç",
      to =
        "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouunc";
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(RegExp(from[i], "gi"), to[i]);
    }

    str = str.toLowerCase().trim();

    return str;
  }

  getRequestType(item) {
    switch (item.REQUEST_TYPE) {
      case "PAYMENT_REQUEST":
        return "ĐỀ NGHỊ CHI";
      case "ADVANCE_REQUEST":
        return "ĐỀ NGHỊ TẠM ỨNG";
    }
  }
  formatDate(pDate)
  {
    if (!pDate)
      return;
    return moment(pDate).format('DD/MM/YYYY HH:mm:ss');

  }
  modifyDateTransactions() {
    return;
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].date_acceptance) {
        var date = new Date(this.data[i].date_acceptance);
        var day, month, year, hour, min;
        day = date.getDate();
        month = date.getMonth() + 1;
        year = date.getFullYear();
        hour = date.getUTCHours();
        min = date.getUTCMinutes();
        this.data[i].date_acceptance =
          day + "-" + month + "-" + year + "  " + hour + ":" + min;
      } else if (this.data[i].DATE_REQUEST) {
        var date = new Date(this.data[i].DATE_REQUEST);
        var day, month, year, hour, min;
        day = date.getDate();
        month = date.getMonth() + 1;
        year = date.getFullYear();
        hour = date.getUTCHours();
        min = date.getUTCMinutes();

        this.data[i].DATE_REQUEST =
          day + "-" + month + "-" + year + " " + hour + ":" + min;
        
        //this.data[i].DATE_REQUEST = date.toLocaleString();

      } else if (this.data[i].REQUEST_DATE) {
        var date = new Date(this.data[i].REQUEST_DATE);
        var day, month, year, hour, min;
        day = date.getDate();
        month = date.getMonth() + 1;
        year = date.getFullYear();
        hour = date.getUTCHours();
        min = date.getUTCMinutes();
        this.data[i].REQUEST_DATE =
          day + "-" + month + "-" + year + ", " + hour + ":" + min;
      }
    }
  }

  ngOnInit() {
    this._origData = this.data;
    this.modifyDateTransactions();
  }

  ngAfterViewChecked() {
    this.changeColorByStatus();
  }
}



// WEBPACK FOOTER //
// ./src/components/act-payment-request/act-payment-request.ts